import { useState } from 'react'
import Banner from './Banner'
import ContactInfo from './ContactInfo'
import ContactForm from './ContactForm'
import MapSection from './MapSection'
import './ContactUs.css'

import Header from "../components/Header";
import Footer from "../components/Footer";



function ContactUs() {
  return (

<> 
<Header/> 


    <div className="contact-us-page">
      <Banner />

      <div className="contact-content">
        <div className="contact-grid">
          <ContactInfo />
          <ContactForm />
        </div>
      </div>

      {/* <Satisfaction /> */}

      <MapSection />
    </div>
    
    <Footer/>
    
    </>
  )
}

export default ContactUs
